import { getUserInfoForAnalytics } from './getUserInfoForAnalytics';
import { logException } from '../logging';
import { amplitudeClients } from '../amplitude';

export const fetchPcpLinkedInfoForAnalytics = async (
    healthSystemToken: string | null | undefined,
    userInfoForAnalytics: string
) => {
    let hasPcp = false;
    let missingDepartment = 'false';
    // Call the backend service only when there us a token present
    if (healthSystemToken) {
        try {
            const result = await getUserInfoForAnalytics({
                token: healthSystemToken,
                userInfoForAnalytics,
            });
            const resp = await result.json();
            hasPcp = resp.hasPcp;
            if (resp.missingDepartment) {
                missingDepartment = resp.missingDepartment;
            }
        } catch (error) {
            if (error instanceof Error) {
                logException('FetchPCPLinkedForAnalytics - Error occurred', {
                    exception: error as Error,
                });
                return;
            }
            logException('FetchPCPLinkedForAnalytics - Error occurred', {
                exception: new Error('Unknown error'),
            });
        }
    }
    amplitudeClients.setUserProperties({
        pcp_linked: hasPcp,
        missing_department: missingDepartment,
        show_new_pcp_appointment_booking_flows: true,
    });
};
